const DELAY_IN_SECS = 0.1;

const ticketFormSettingsMock = {
  availableComunicationLanguagesByCode: ['ES', 'FR'],
  availableDestinationCountriesByCode: ['ES', 'IT'],
  availableServicesByCode: ['SER1', 'SER2'],
};

// get a mock
const getTicketFormSettings = async (...args) => {
  await new Promise((r) => setTimeout(r, DELAY_IN_SECS * 1000));
  return ticketFormSettingsMock;
};

export default getTicketFormSettings;
